































import { Vue, Component, Prop } from "vue-property-decorator";
import { UpmindObjectTypes } from "@/data/enums/objects";

@Component
export default class TwoFaSwitch extends Vue {
  @Prop({ required: true })
  public value!: any;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  @Prop({ required: false, default: UpmindObjectTypes.USER })
  public objectType!: UpmindObjectTypes.USER | UpmindObjectTypes.CLIENT;
}
